import { render, staticRenderFns } from "./Dialog-memo.vue?vue&type=template&id=669c72d6&"
import script from "./Dialog-memo.vue?vue&type=script&lang=js&"
export * from "./Dialog-memo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports